// @flow
import React from "react";
import styled, { css } from "styled-components";

import type { IconProps } from "./";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function DateIcon({
  width = "18px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.828 15.2"
      fill={fill}
      width={width}
      {...props}
    >
      <path d="M0,15.2V1.6H2.674V0H4.457V1.6H6.24V0H8.023V1.6H9.806V0h1.783V1.6h1.783V0h1.783V1.6h2.674V15.2Zm1.783-1.6H16.046V3.2h-.892V4H13.371V3.2H11.588V4H9.806V3.2H8.023V4H6.24V3.2H4.457V4H2.674V3.2H1.783Zm9.805-2.4V9.6h1.783v1.6Zm-3.566,0V9.6H9.806v1.6Zm-3.566,0V9.6H6.24v1.6ZM11.588,8V6.4h1.783V8ZM8.023,8V6.4H9.806V8ZM4.457,8V6.4H6.24V8Z" />
    </svg>
  );
}

export const StyledDateIcon = styled(DateIcon)`
  ${({ theme }) => {
    if (theme.direction === "rtl") {
      return css`
        margin-left: 12px;
      `;
    }

    return css`
      margin-right: 12px;
    `;
  }};
`;



// WEBPACK FOOTER //
// ./src/components/Icons/Date.js